import {useCallback, useContext} from 'react';
import {Base64} from 'js-base64';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useMst} from "../models";
import {ThemeContext} from "@emotion/react";
import Configs from "../models/Configs";
import companyService from "../services/CompanyService";
import showNotification from "../components/extras/showNotification";
import {demoPages} from "../menu";

const useAuthenticatedCallback = () => {
	const {user, company} = useMst();
	const {mobileDesign} = useContext(ThemeContext);
	const navigate = useNavigate();
	const {t} = useTranslation();

	return useCallback(async (finalState) => {
		try {
			await user.authMe();

			await Promise.all([
				Configs.sendDevice(),
				user.me.currentCompanyId
					? company.selectCompany(
						user.me.currentCompanyId,
						mobileDesign,
						finalState && !finalState.includes('requestId')
					)
					: Promise.resolve()
			]);

			if (!user.me.id) return;

			if (!finalState?.includes('requestId')) {
				window.location.replace(
					!user.me.currentCompanyId
						? '/change-company'
						: finalState || '/'
				);

				return;
			}

			const {
				state: approvalState,
				requestId
			} = JSON.parse(finalState);

			const resAppr = await companyService.approval({
				id: requestId,
				userId: user.me.id,
				state: approvalState.replace(/CANCEL|PLAN/g, '')
			});

			const logoResponse = await companyService.info({
				id: company.id
			});

			sessionStorage.setItem(
				'approvalResult',
				Base64.encode(
					JSON.stringify({
						state: approvalState,
						result: resAppr?.result,
						message: resAppr?.result
							? ''
							: resAppr?.data?.message,
						logo: logoResponse.data.logoBase64
					})
				)
			);

			window.location.href = '/vacation.request.approval.html';
		} catch (error) {
			console.error('인증 이후 처리 실패:', error);

			showNotification(
				t('로그인'),
				`${t('로그인에 실패하였습니다.')}${t('다시 확인해주세요')}.`,
				'danger'
			);

			navigate('/' + demoPages.login.path);
		}
	}, [
		user,
		company,
		mobileDesign,
		navigate,
		t
	]);
};

export default useAuthenticatedCallback;